import React from 'react';

import PropTypes from 'prop-types';
import { Button, Modal } from 'semantic-ui-react';

import CloseableModal from 'components/common/CloseableModal';
import ExternalAnchor from 'components/common/ExternalAnchor';

import { LocationInfoDetailRowPropType } from './LocationInfoModal.types';

import './LocationInfoModal.scss';

const propTypes = {
  open: PropTypes.bool,
  header: PropTypes.string,
  details: PropTypes.arrayOf(LocationInfoDetailRowPropType),
  onClose: PropTypes.func.isRequired,
};

const defaultProps = {
  open: false,
  header: '',
  details: [],
};

function LocationInfoModal({ open, header, details, onClose }) {
  return (
    <CloseableModal
      open={open}
      onClose={onClose}
      size="tiny"
      className="information-modal location-info-modal"
      header={header}
    >
      <Modal.Content>
        <div className="location-info-modal__body">
          {details.map(({ label, value }) => (
            <p key={label} className="location-info-modal__row">
              <strong>{label}</strong>
              {label === 'Maps URI' ? (
                <ExternalAnchor href={value}>View on Google Maps</ExternalAnchor>
              ) : (
                <span>{value}</span>
              )}
            </p>
          ))}
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button primary content="Close" onClick={onClose} />
      </Modal.Actions>
    </CloseableModal>
  );
}

LocationInfoModal.propTypes = propTypes;
LocationInfoModal.defaultProps = defaultProps;

export default LocationInfoModal;
